import config from 'config/config'
import {
  classNames,
  sortableListDragSourceDragMarker,
  sortableListDropTargetDragMarker,
} from 'lib/utilities'
import React from 'react'
import { DragSource, DropTarget } from 'react-dnd'
import { Icon, Table } from 'semantic-ui-react'

class ProductAccessoryRow extends React.Component {
  render() {
    const { index, accessory, unlinkAccessory, dragMarker = {} } = this.props //ownProps
    const { isDragging, connectDragSource, connectDropTarget } = this.props //DragSource,DropTarget
    let rowClass = isDragging && 'isDragging'
    let dragIndicator
    if (dragMarker.index === index) {
      dragIndicator = dragMarker.position
    }
    return connectDragSource(
      connectDropTarget(
        <tr className={classNames([rowClass, dragIndicator])}>
          <Table.Cell
            width={1}
            className="draggable"
            content={<Icon {...config.icons.draggable} link />}
          />
          <Table.Cell width={10} className="ellipsis">
            {accessory.kind === 'product'
              ? accessory.product.article_number
              : accessory.category.text}
            <br />
            {accessory.kind === 'product' && (
              <span className="german tag">{accessory.product.title_de}</span>
            )}
            {accessory.kind === 'product' && (
              <span className="french tag">{accessory.product.title_fr}</span>
            )}
          </Table.Cell>
          <Table.Cell width={1} textAlign="right">
            <Icon
              link
              {...config.icons.unlink}
              onClick={() => unlinkAccessory(index)}
            />
          </Table.Cell>
        </tr>
      )
    )
  }
}

ProductAccessoryRow = DropTarget(
  'ProductAccessory',
  sortableListDropTargetDragMarker,
  (connect) => ({ connectDropTarget: connect.dropTarget() })
)(ProductAccessoryRow)
ProductAccessoryRow = DragSource(
  'ProductAccessory',
  sortableListDragSourceDragMarker,
  (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  })
)(ProductAccessoryRow)
export default ProductAccessoryRow



// WEBPACK FOOTER //
// ./src/components/admin/Products/Segments/ProductAccessoryRow.jsx